import React     from 'react';
import useStyles from './loginFormStyles';

import Box       from '@mui/material/Box';
import Button    from '@mui/material/Button';
import Grid      from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Tooltip   from '@mui/material/Tooltip';

import PropTypes          from 'prop-types';
import { useTranslation } from 'react-i18next';


function LoginForm(props) {

  const { t }       = useTranslation();
  const { classes } = useStyles();

  const [fieldErrors, setFieldErrors] = React.useState({});

  function clearFieldError(fieldName) {
    setFieldErrors(prevState => {
      const newState      = { ...prevState };
      newState[fieldName] = false
      return newState;
    })
  }

  /**
   * This handler is run separately for each invalid field.
   */
  function handleInvalid(evt) {
    //corresponds to name attribute inside the <form>
    const invalidFieldName = evt.target.name;
    setFieldErrors(prevState => {
      const newState             = { ...prevState };
      newState[invalidFieldName] = true
      return newState;
    })
  }

  function fieldProps(fieldName, fieldType) {
    return {
      required:  true,
      type:      fieldType,
      name:      fieldName,
      fullWidth: true,
      className: classes.field,
      error:     fieldErrors[fieldName],
      onChange:  () => clearFieldError(fieldName)
    };
  }

  let tooltipTitle = '';
  if (props.isInProgress)
    tooltipTitle = t('inProgress')

  //TODO add icons as end adornments

  return (
    <Box component='form' onSubmit={props.onSubmit} onInvalid={handleInvalid}>
      <Grid
        container
        direction='column'
        spacing={3}
        paddingTop={2}
        paddingBottom={3}
        paddingLeft={4}
        paddingRight={4}
        justifyContent='center'
        alignItems='stretch'
      >
        <Grid item>
          <TextField
            {...fieldProps('username', 'email')}
            label={t('usernameFieldLabel')}
          />
        </Grid>
        <Grid item>
          <TextField
            {...fieldProps('password', 'password')}
            label={t('passwordFieldLabel')}
          />
        </Grid>
        <Grid item>
          <Tooltip title={tooltipTitle}>
            <span> {/*//Disabled elements can't hold a ref required by Tooltip*/}
              <Button
                type="submit"
                fullWidth
                disabled={props.isInProgress}
                className={classes.loginButton}
                color='secondary'
              >
                {t('loginButton')}
              </Button>
            </span>
          </Tooltip>
        </Grid>
      </Grid>
    </Box>);
}

LoginForm.propTypes = {
  onSubmit:     PropTypes.func.isRequired,
  isInProgress: PropTypes.bool
};

export default LoginForm;